import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import './companyName.css'

class CompanyName extends Component {

  state = {
    results: [],
  }

  fetchCompanies = (query) =>
    fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${query}`)
    .then(res => res.json())
    .then((results) => {
      this.setState({
        results
      })
    })

  handleValue (value) {
    this.props.updateValue(value)

    this.props.value.length > 1
    ? this.fetchCompanies(value)
    : this.setState({results: []})
  }

  clearInput() {
    this.setState({results: []})
    this.props.updateValue('')
  }

  handleSubmit(company) {
    this.props.handleCompanySubmit(company)
    this.clearInput()
  }

  handleKeyDown(data) {
    const { name, domain, logo } = data
    if (data.event.keyCode === 13) {
      this.handleSubmit({ name, domain, logo })
    }
    this.props.scroll()
  }

  handleClick = e => {
    if(!ReactDOM.findDOMNode(this).contains(e.target)) {
      this.setState({results: []})
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false);
  }

  customStyle(key) {
    if (key === 0) {
      return "company-list-item first-item"
    } else if (key === 4) {
      return "company-list-item last-item"
    } else {
      return "company-list-item"
    }
  }

  render() {
    return(

        <div className="company-input-group"  ref={node => this.node = 'node'}>

          {this.state.results.length > 0 &&
            <div className='company-select-panel drop-shadow-large'>
              {
                this.state.results.map((result, key) =>
                  <div
                    key={key}
                    className={this.customStyle(key)}
                    onClick={() => this.handleSubmit(result)}
                  >
                    <p>{result.name}</p>
                    <small>{result.domain}</small>
                  </div>
                )
              }
              <div className='company-list-item-empty' />
            </div>
          }

          <input
            className='single-line-company-input'
            onChange={(event) => this.handleValue(event.target.value)}
            value={this.props.value}
            autoFocus={true}
            onKeyDown={(event) => this.handleKeyDown({event, name: this.props.value, domain: '', logo: ''})}
            placeholder={this.props.placeholder}
          />



        </div>

    )
  }
}

export default CompanyName
